
import { computed, onMounted, ref } from '@vue/runtime-core';
import SocialSharing from '@/components/general/WdwSocialSharing.vue';
import AttributeList from '@/components/discuss/thought/AttributeTags.vue';
import useStringManip from '@/composables/general/useStringManip';
export default {
  name: 'PreviewThought',
  components: { SocialSharing, AttributeList },
  props: {
    thought: { type: Object, required: true },
    thoughtListHeight: {
      type: Number,
      default: 600,
    },
    moreLink: {
      type: String,
      required: true,
    },
  },

  setup(props: any) {
    const { getPlainText } = useStringManip();
    //REF
    const thoughtURL = ref(props.moreLink + '?thought_id=' + props.thought.id);

    //COMPUTED
    const wrapperClass = computed(() => {
      return { height: props.thoughtListHeight + 'px' };
    });

    //METHODS
    function readMore() {
      window.location.href = thoughtURL.value;
    }

    return {
      getPlainText,
      //REF
      thoughtURL,
      //METHODS
      readMore,
      //COMPUTED
      wrapperClass,
    };
  },
};
